<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center ">
        <a-input-search placeholder="Zoeken" style="width: 200px" class="mr-2" v-model="search" />
        <a-range-picker :placeholder="['Start dag', 'Eind dag']" class="mr-2" v-model="date" @change="onChange" />
        <a-button type="danger" @click="clearDate() " icon="close" />
      </div>
      <div class="d-flex align-items-center">
        <div class="mx-2" v-if="invoices.length > 0">
          <a-tag color="blue">
            Aantal facturen
          </a-tag>
          {{invoices.length}}
        </div>
        <div class="mx-2" v-if="factuurTotalen.totaalBetaald">
          <a-tag color="green">
            Betaald
          </a-tag>
          {{factuurTotalen.totaalBetaald | currency}}
        </div>
        <div class="mx-2" v-if="factuurTotalen.totaalNietBetaald">
          <a-tag color="red">
            Niet betaald
          </a-tag>
          {{factuurTotalen.totaalNietBetaald | currency}}
        </div>
      </div>
    </div>
    <br />
    <a-button v-if="selectedInvoicesRowKeys.length > 0" type="primary" @click="streamInvoicePDFArray()" >Open geselecteerde facturen</a-button>
    <br />
    <div>
      <a-table :columns="columns" :pagination="{pageSize: 50}" :data-source="invoices"  :row-selection="{ selectedRowKeys: selectedInvoicesRowKeys, onChange: onSelectChange }" rowKey="id">
        <span slot="tags" slot-scope="text, invoice">
          <a-tag v-if="invoice.credit" color="red">
            Creditnota
          </a-tag>
          <a-tag v-if="!invoice.paid" color="red">
            Niet betaald
          </a-tag>
          <a-tag v-if="!invoice.sent_at" color="red">
            Nog niet verstuurd
          </a-tag>
          <a-tag v-if="invoice.sent_at" color="green">
            {{invoice.invoice_sent_count? parseNumberToText(invoice.invoice_sent_count-1) +' herinnering verstuurd' :'Verstuurd'}} 
          </a-tag>
          <a-tag v-if="invoice.paid" color="green">
            Betaald
          </a-tag>
        </span>
        <span slot="factuurTotaal" slot-scope="invoice">
          <div v-if="invoice.organization.commission">
            {{((invoice.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0)/100)*(100 - invoice.organization.commission_amount)) | currency}}
          </div>
          <div v-else>
            {{invoice.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0) | currency}}
          </div>
        </span>
        <span slot="action" slot-scope="text, invoice">
          <a-dropdown-button @click="streamInvoicePDF(invoice.id, invoice)">
            Bekijk Factuur
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="downloadInvoicePDF(invoice.id, invoice)"> <a-icon type="download" />Download Factuur</a-menu-item>
              <a-menu-item key="2" v-if="invoice.credit == false && invoice.sent_at === null" @click="sendInvoice(invoice.id)"> <a-icon type="mail" />Verstuur factuur naar klant</a-menu-item>
              <a-menu-item key="6" v-if="invoice.credit == false && invoice.sent_at !== null" @click="sendInvoiceReminder(invoice.id)"> <a-icon type="mail" />Verstuur factuurherinnering naar klant</a-menu-item>
              <a-menu-item key="3" v-if="invoice.credit == false" @click="generateCredit(invoice)"> <a-icon type="issues-close" />Maak creditnota aan</a-menu-item>
              <a-menu-item key="4" v-if="invoice.paid == false" @click="markAsPaid(invoice)"> <a-icon type="euro" />Factuur markeren als "betaald"</a-menu-item>
              <a-menu-item key="5" v-if="invoice.paid == true" @click="markAsNotPaid(invoice)"> <a-icon type="euro" />Factuur markeren als "niet betaald"</a-menu-item>
              <a-menu-item key="7" v-if="invoice.sent_at" @click="showMailSentModal(invoice)"> <a-icon type="mail" />Toon mailgeschiedenis</a-menu-item>
            </a-menu>
          </a-dropdown-button>
        </span>
      </a-table>
      <a-modal
      title="Mail geschiedenis"
      :visible="mailHistoryShow"
      @ok="mailHistoryShow = false"
      @cancel="mailHistoryShow = undefined"
    >
      <ul v-for="mail, i in mailHistory">
        <li v-if="i !== 0">{{parseNumberToText(i)}} herinnering verstuurd op {{formatDate(mail.created_at)}}</li>
        <li v-if="i === 0">Verstuurd op {{formatDate(mail.created_at)}}</li>
      </ul>
    </a-modal>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
const columns = [
  {
    title: 'Factuurnummer',
    width: 150,
    dataIndex: 'invoice_number',
    key: 'id',
    sorter: (a, b) => a.invoice_number - b.invoice_number,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Bedrijfsnaam',
    width: 200,
    dataIndex: 'organization_name',
    
    sorter: (a, b) => {
      return a.organization_name.localeCompare(b.organization_name); //using String.prototype.localCompare()
    },
    sortDirections: ['descend',  'ascend'],
  },
  {
    title: 'Aangemaakt op',
    width: 150,
    dataIndex: 'generated_at',
    defaultSortOrder: 'descend',
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    sorter: (a, b) => {return moment(a.generated_at, 'YYYY-MM-DD HH:mm:ss').valueOf() - moment(b.generated_at, 'YYYY-MM-DD HH:mm:ss').valueOf()},
    customRender: (text, record, index)=>{ return moment(record.generated_at, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')},
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Verstuurd op',
    width: 200,
    dataIndex: 'sent_at',
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    customRender: (text, record, index)=>{return record.sent_at ? 'Verstuurd op '+moment(record.sent_at, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY') : 'Nog niet verstuurd'},
    sorter: (a, b) => {return moment(a.sent_at, 'YYYY-MM-DD HH:mm:ss').valueOf() - moment(b.sent_at , 'YYYY-MM-DD HH:mm:ss').valueOf()},
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Totaal',
    key: 'factuurTotaal',
    width: 100,
    scopedSlots: { customRender: 'factuurTotaal' },
  },
  {
    title: 'Tags',
    key: 'tags',
    filters: [
      {
        text: 'Creditnota',
        value: '-credit-',
      },
      {
        text: 'Betaald',
        value: '-betaald-',
      },
      {
        text: 'Niet betaald',
        value: '-nietbetaald-',
      },
      {
        text: 'Verstuurd',
        value: '-verstuurd-',
      },
      {
        text: 'Niet verstuurd',
        value: '-nietverstuurd-',
      },
    ],
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    onFilter: (value, record) => {
      let customString = "";
      if(record.credit){
        customString += "-credit-";
      }
      if(record.paid){
        customString += "-betaald-";
      }
      if(!record.paid){
        customString += "-nietbetaald-";
      }
      if(record.sent_at){
        customString += "-verstuurd-";
      }
      if(!record.sent_at){
        customString += "-nietverstuurd-";
      }
      if(customString.indexOf(value) !== -1){
        return record;
      }
    },
    scopedSlots: { customRender: 'tags' },
  },
  {
    title: 'Acties',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
  
];


  export default {
    computed: {
      user: {
        get: function () {
          return this.$store.state.user
        },
      },
    },
    data(){
      return {
        date: undefined,
        mailHistoryShow: false,
        mailHistory: [],
        selectedInvoicesRowKeys: [],
        selectedInvoicesRowItems: [],
        startDate: undefined,
        endDate: undefined,
        invoices: [],
        search: '',
        downloadingPdf: false,
        streamPdf: false,
        columns,
        factuurTotalen:  {
          totaal: false,
          totaalBetaald: false,
          totaalNietBetaald: false
        }
      }
    },
    watch: {
      search(){
        this.getInvoices();
      }
    },
    mounted(){
      this.getInvoices();
      
    },
    methods: {
      clearDate(){
        this.startDate = undefined;
        this.endDate = undefined;
        this.date = undefined;
        this.getInvoices();
      },
      onChange(date, dateString) {
        this.startDate = dateString[0];
        this.endDate = dateString[1];
      // this.reservationsLoading = true;
      this.getInvoices()
    },
      getInvoices(){
        this.$axios.get('/invoice/list', {
        params: {
          search: this.search,
          startDate: this.startDate ? this.startDate : undefined,
          endDate: this.endDate ? this.endDate : undefined,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          this.invoices = response.data;
          this.factuurTotalen = {
            totaal: false,
            totaalBetaald: false,
            totaalNietBetaald: false
          }
          this.invoices.forEach(invoice=>{
            let total;
            if(invoice.organization.commission){
              total = ((invoice.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0)/100)*(100 - invoice.organization.commission_amount)) 
            }else{
              total = invoice.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0)
            }
            if(invoice.paid){
              if(this.factuurTotalen.totaalBetaald === false){
                this.factuurTotalen.totaalBetaald = 0;
              }
              this.factuurTotalen.totaalBetaald += total;
            }else{
              if(this.factuurTotalen.totaalNietBetaald === false){
                this.factuurTotalen.totaalNietBetaald = 0;
              }
              this.factuurTotalen.totaalNietBetaald += total;
            }
            if(this.factuurTotalen.totaal === false){
              this.factuurTotalen.totaal = 0;
            }
            this.factuurTotalen.totaal += total
          })
        })
      },
      parseNumberToText(number){
        // 1ste 2de 3de etc
        let numberString = number.toString();
        let lastNumber = numberString.substr(numberString.length - 1);
        let lastTwoNumbers = numberString.substr(numberString.length - 2);
        if(lastTwoNumbers === "11" || lastTwoNumbers === "12" || lastTwoNumbers === "13"){
          return number + "de";
        }
        if(lastNumber === "1"){
          return number + "ste";
        }
        if(lastNumber === "2"){
          return number + "de";
        }
        if(lastNumber === "3"){
          return number + "de";
        }
        return number + "de";
      },
      showMailSentModal(invoice){
        this.mailHistoryShow = true;
        this.mailHistory = invoice.invoice_sent;
      },
      formatDate(date) {
      return this.moment(date).format('DD-MM-YYYY HH:mm')
    },
      downloadInvoicePDF(invoice_id, invoice){
        this.downloadingPdf = true;
        this.$axios.get('/invoice/download', {
        params: {
          invoice_id
        },
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Royal Parking - Factuur #${invoice.invoice_number}.pdf`); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.downloadingPdf = false;
        })
      },
      streamInvoicePDF(invoice_id, invoice){
        this.streamPdf = true;
        this.$axios.get('/invoice/stream', {
        params: {
          invoice_id
        },
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          console.log(response.data);
          let file = new Blob([response.data], { type: 'application/pdf;base64' });
          let fileURL = URL.createObjectURL(file);
          let w = window.open(fileURL);
          w.document.title = `Royal Parking - Factuur #${invoice.invoice_number}.pdf`;
          this.streamPdf = false;
        })
      },
      streamInvoicePDFArray(invoice_id, invoice){
        this.streamPdf = true;
        this.$axios.get('/invoice/streamArray', {
        params: {
          invoice_ids: this.selectedInvoicesRowItems.map(invoice=>{
            return invoice.id
          })
        },
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          console.log(response.data);
          let file = new Blob([response.data], { type: 'application/pdf;base64' });
          let fileURL = URL.createObjectURL(file);
          let w = window.open(fileURL);
          w.document.title = `Royal Parking - Factuur #${invoice.invoice_number}.pdf`;
          this.streamPdf = false;
        })
      },
      generateCredit(invoice) {
        this.$axios.post('/credits/generate', {
          invoice_id: invoice.id
        },
        {
          headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }
        } ).then(response => {
          this.getInvoices();
        })
      },
      markAsPaid(invoice){
        this.$axios.post('/invoice/markAsPaid', {
          invoice_id: invoice.id
        },
        {
          headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }
        } ).then(response => {
          this.getInvoices();
        })
      },
      markAsNotPaid(invoice){
        this.$axios.post('/invoice/markAsNotPaid', {
          invoice_id: invoice.id
        },
        {
          headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }
        } ).then(response => {
          this.getInvoices();
        })
      },
      sendInvoice(invoice_id){
        this.$axios.post('/invoice/send', {
        invoice_id
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response=>{
        this.getInvoices();
      })
      },
      sendInvoiceReminder(invoice_id){
        this.$axios.post('/invoice/reminder', {
        invoice_id
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response=>{
        this.getInvoices();
      })
      },
      onSelectChange(selectedRowKeys, i) {
        console.log('selectedRowKeys changed: ', selectedRowKeys, i)
        this.selectedInvoicesRowKeys = selectedRowKeys;
        this.selectedInvoicesRowItems = i;

      },
    }
  }
</script>
<style>
.invoice__block{
  border-bottom: 1px solid black;
}
</style>